import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    pillContainer: {
      width: '100%',
      margin: '10px 0 10px 1px',
      padding: '12px 25px 13px 24px',
      border: 'solid 1px #5f7ccf',
      borderRadius: '50px 25px 25px 50px',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        flexWrap: 'wrap',
        borderRadius: '50px 50px 50px 50px',
        padding: '16px 25px 19px 19px',
        margin: '20px 0 20px 1px',
      },
    },
    providerInfoContainer: {
      maxWidth: 'calc(100% - 296px)',
      [theme.breakpoints.down('xs')]: {
        maxWidth: 'calc(100% - 60px)',
      },
    },
    buttonContainer: {
      [theme.breakpoints.down('xs')]: {
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        width: '100%',
        marginTop: 20,
      },
    },
  }),
);
